/* clickable-about-anchors.js -- About-page scrollspy (round 4, 06 Aug 2026).
   Behaviour clone of the live theme's anchor.js, verbatim algorithm:
   - target positions cached at DOMContentLoaded and on resize (absolute
     page offsets);
   - active pill = the LAST target whose top <= scrollY + 240;
   - click = preventDefault + smooth window.scrollTo(target top) -- no
     offset (live parity);
   - active class lives on the <li>.
   Run-once guard per rule 21 corollary (shared tags execute per emission). */
(function () {
  'use strict';
  if (window.__ckAboutAnchorsInit) return;
  window.__ckAboutAnchorsInit = true;

  document.addEventListener('DOMContentLoaded', function () {
    var items = document.querySelectorAll('.ck-about-anchors__item');
    if (!items.length) return;
    var targetPositions = [];

    var updateTargetPositions = function () {
      targetPositions.length = 0;
      items.forEach(function (item) {
        var link = item.querySelector('a');
        if (!link) return;
        var targetId = link.getAttribute('href');
        var targetElement;
        try { targetElement = document.querySelector(targetId); } catch (e) { targetElement = null; }
        if (targetElement) {
          var position = targetElement.getBoundingClientRect().top + window.pageYOffset;
          targetPositions.push({ id: targetId, position: position });
        }
      });
    };

    var updateActiveAnchor = function () {
      var currentPosition = window.pageYOffset + 240;
      for (var i = targetPositions.length - 1; i >= 0; i--) {
        if (currentPosition >= targetPositions[i].position) {
          var activeItem = document.querySelector('.ck-about-anchors__item.active');
          if (activeItem) activeItem.classList.remove('active');
          var anchorLink = document.querySelector('.ck-about-anchors__item a[href="' + targetPositions[i].id + '"]');
          if (anchorLink) {
            anchorLink.parentElement.classList.add('active');
            break;
          }
        }
      }
    };

    items.forEach(function (item) {
      var anchorLink = item.querySelector('a');
      if (!anchorLink) return;
      anchorLink.addEventListener('click', function (event) {
        var targetId = anchorLink.getAttribute('href');
        var targetElement;
        try { targetElement = document.querySelector(targetId); } catch (e) { targetElement = null; }
        if (!targetElement) return;
        event.preventDefault();
        var position = targetElement.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({ top: position, behavior: 'smooth' });
      });
    });

    updateTargetPositions();
    updateActiveAnchor();
    window.addEventListener('scroll', updateActiveAnchor);
    window.addEventListener('resize', updateTargetPositions);
  });
})();
